import React, { useState, useEffect } from 'react';

const Photos = () => {
  const [photos, setPhotos] = useState([]);
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    fetch('http://localhost:4007/photos')
      .then(res => res.json())
      .then(data => setPhotos(data))
      .catch(() => {
        window.location.href = '/error';
      });
  }, []);

  const handleFileChange = e => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async e => {
    e.preventDefault();
    if (!file || !title) return;
    setUploading(true);

    try {
      const res = await fetch('http://localhost:4007/photos/upload-url', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ filename: file.name, filetype: file.type }),
      });
      const { uploadUrl, imageUrl } = await res.json();

      // Upload the file directly to S3
      await fetch(uploadUrl, {
        method: 'PUT',
        headers: { 'Content-Type': file.type },
        body: file,
      });

      // Save photo metadata to your backend
      await fetch('http://localhost:4007/photos', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          image_url: imageUrl,
          title,
          description,
          user_id: JSON.parse(localStorage.getItem('user'))?.id || null,
        }),
      });

      setFile(null);
      setTitle('');
      setDescription('');
      setUploading(false);

      // Refresh photo list
      fetch('http://localhost:4007/photos')
        .then(res => res.json())
        .then(data => setPhotos(data));
    } catch (err) {
      window.location.href = '/error';
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Photo Gallery</h2>
      <div style={{ textAlign: 'center', color: '#555', marginBottom: '24px', fontSize: '1.1rem' }}>
        Add photos of you work, We suggest 5-10 of your best photos.
      </div>
      <form style={styles.form} onSubmit={handleUpload}>
        <input type="file" accept="image/*" onChange={handleFileChange} style={styles.input} />
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={e => setTitle(e.target.value)}
          style={styles.input}
          required
        />
        <input
          type="text"
          placeholder="Description"
          value={description}
          onChange={e => setDescription(e.target.value)}
          style={styles.input}
        />
        <button type="submit" style={styles.button} disabled={uploading}>
          {uploading ? 'Uploading...' : 'Upload Photo'}
        </button>
      </form>
      <div style={styles.grid}>
        {photos.map(photo => (
          <div key={photo.id} style={styles.card}>
            <img src={photo.image_url} alt={photo.title} style={styles.img} />
            <div style={styles.cardBody}>
              <h4 style={styles.cardTitle}>{photo.title}</h4>
              <p style={styles.cardDesc}>{photo.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '900px',
    margin: '40px auto',
    padding: '24px',
    background: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  title: {
    marginBottom: '24px',
    color: '#4078c0',
    fontSize: '2rem',
    textAlign: 'center',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginBottom: '32px',
    alignItems: 'center',
  },
  input: {
    width: '100%',
    maxWidth: '400px',
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #dbe6f6',
    fontSize: '1rem',
  },
  button: {
    padding: '12px 32px',
    borderRadius: '6px',
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '1rem',
    border: 'none',
    cursor: 'pointer',
    marginTop: '8px',
  },
  grid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '24px',
    justifyContent: 'center',
  },
  card: {
    background: '#f5f6fa',
    borderRadius: '8px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
    width: '260px',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  img: {
    width: '100%',
    height: '180px',
    objectFit: 'cover',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
  },
  cardBody: {
    padding: '16px',
    width: '100%',
  },
  cardTitle: {
    fontSize: '1.1rem',
    fontWeight: 'bold',
    marginBottom: '8px',
    color: '#4078c0',
  },
  cardDesc: {
    fontSize: '0.95rem',
    color: '#555',
  },
};

export default Photos;